const VideoModal = ({ isOpen, videoLink, onClose }) => {
  if (!isOpen) return null;

  const getEmbedUrl = (url) => {
    // Regex to extract video ID from various YouTube URL formats
    const regExp = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
    const match = url.match(regExp);

    if (match && match[1]) {
      // CORRECTED: Ensure 'https://' is used here
      return `https://www.youtube.com/embed/${match[1]}?autoplay=1`;
    }
   
    // This part handles URLs that might be in a simplified format like 'http://googleusercontent.com/youtube.com/ID'
    // where ID is directly the video ID. Ensure 'https://' is used here too.
    const googleUserContentMatch = url.match(/http:\/\/googleusercontent\.com\/youtube\.com\/(\d+)$/);
    if (googleUserContentMatch && googleUserContentMatch[1]) {
        // CORRECTED: Ensure 'https://' is used here
        return `https://www.youtube.com/embed/${googleUserContentMatch[1]}?autoplay=1`;
    }

    // Fallback: If no YouTube video ID is found, try to force HTTPS on the original URL.
    // This is a less reliable fallback for non-standard YouTube URLs.
    try {
        const parsedUrl = new URL(url);
        parsedUrl.protocol = 'https:'; // Force protocol to HTTPS
        return parsedUrl.toString();
    } catch (e) {
        console.error("Invalid URL format:", url, e);
        return url; // Return original if URL parsing fails
    }
  };

  const embedLink = videoLink ? getEmbedUrl(videoLink) : '';


  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Using the button styles you provided */}
        <button className="button yellow-button icon-button video-modal-close" onClick={onClose}>×</button>
        {embedLink && (
          <iframe
            width="100%"
            height="100%"
            src={embedLink} // This will now correctly be an HTTPS URL
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}
      </div>
    </div>
  );
};

export default VideoModal;